function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m102.469 437.232v74.768h106.224v-117.545z",
  fill: "#ffb655"
}), /*#__PURE__*/React.createElement("path", {
  d: "m190.026 347.098-70.498-70.498-11.22 11.22c-12.445 12.445-12.445 32.622 0 45.067l23.916 23.916-18.814 18.814-64.676-64.677v-59.334c0-17.6-14.267-31.867-31.867-31.867h-16.867v117.601l99.892 99.892c24.89 24.89 65.244 24.89 90.134 0 24.89-24.89 24.89-65.245 0-90.134z",
  fill: "#864927"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m409.531 437.232v74.768h-106.224v-117.545z",
  fill: "#e06a50"
})), /*#__PURE__*/React.createElement("path", {
  d: "m321.974 347.098 70.498-70.498 11.22 11.22c12.445 12.445 12.445 32.622 0 45.067l-23.916 23.916 18.814 18.814 64.676-64.676v-59.334c0-17.6 14.267-31.867 31.867-31.867h16.867v117.6l-99.892 99.892c-24.89 24.89-65.244 24.89-90.134 0-24.89-24.89-24.89-65.245 0-90.134z",
  fill: "#e3a76f"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m182.69 0c-48.091 0-87.076 38.985-87.076 87.076 0 0-7.28 95.087 160.386 203.924l30-126-30-124.93c-15.486-24.102-42.533-40.07-73.31-40.07z",
  fill: "#e06a50"
}), /*#__PURE__*/React.createElement("path", {
  d: "m416.386 87.076c0-48.091-38.985-87.076-87.076-87.076-30.777 0-57.824 15.968-73.31 40.07v250.93c167.666-108.836 160.386-203.924 160.386-203.924z",
  fill: "#c53232"
})));

var SvgVolunteerIcon = function SvgVolunteerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolunteerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volunteer_icon.d13b2d61.svg";
export { ForwardRef as ReactComponent };